<template>
  <div>
    <div class="row">
      <span class="font-weight-bold">
        Futamidő
      </span>
      <span class="font-weight-light">
        (hónap)
      </span>
    </div>
    <div class="row mb-2">
      <div
        v-for="each of contractLengths"
        :key="'contract_lengths' + each"
        class="col"
      >
        <button
          type="button"
          :class="{'btn-light': each !== contractLength, 'btn-primary': each === contractLength }"
          class="btn btn-square btn-sm btn-block"
          @click="setContractLength(each)"
        >
          {{ each }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const configuratorModule = namespace('configurator');
  @Component
  export default class ContractLengthSelector extends Vue {
    @configuratorModule.Getter('getContractLengths') contractLengths;
    @configuratorModule.Getter('getContractLength') contractLength;
    @configuratorModule.Mutation('setContractLength') setContractLength;

    @Prop(Object) lead;
  }
</script>
